import React from 'react';
import { motion } from 'framer-motion';
import { Logo } from './Logo';
import { Play } from 'lucide-react';
export function Hero() {
  return <section className="relative w-full min-h-screen bg-white flex flex-col pt-6 pb-20 md:pt-8 md:pb-32 px-6 md:px-12 lg:px-24 overflow-hidden" data-id="element-11">
      {/* Header / Nav */}
      <header className="w-full max-w-6xl mx-auto flex justify-start items-center mb-16 md:mb-20 z-10" data-id="element-12">
        <Logo data-id="element-13" />
      </header>

      {/* Main Content - Centered Single Column */}
      <div className="w-full max-w-4xl mx-auto flex flex-col items-center text-center z-10 flex-grow" data-id="element-14">
        {/* Callout chip */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        ease: 'easeOut'
      }} className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-bg-primary/5 border border-bg-primary/10 mb-6 md:mb-8" data-id="element-15">
          <div className="w-2 h-2 rounded-full bg-accent" data-id="element-16"></div>
          <span className="text-xs md:text-sm font-semibold tracking-wider text-bg-primary uppercase" data-id="element-17">
            For $250M+ AUM Advisors at Wirehouses & Advisor Teams
          </span>
        </motion.div>

        {/* Headline */}
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        ease: 'easeOut',
        delay: 0.1
      }} className="font-display font-extrabold text-[40px] leading-[1.1] md:text-[56px] lg:text-[64px] tracking-tightest text-bg-primary mb-6 md:mb-8 max-w-4xl" data-id="element-18">
          Our AI Already Knows Which Independent RIA's Will Pay A Cash Premium
          For Your Business
        </motion.h1>

        {/* Subheadline */}
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        ease: 'easeOut',
        delay: 0.2
      }} className="text-lg md:text-[22px] leading-relaxed text-bg-primary mb-12 md:mb-16 max-w-3xl" data-id="element-19">
          Our proprietary AI tracks 10,000+ independent RIAs across AUM range,
          geography, client profile, and advisor teams. We'll identify the 3 to
          5 best matches, introduce you privately, and negotiate your transition
          capital — at zero cost to you.
        </motion.p>

        {/* VSL - Centered in the middle */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        ease: 'easeOut',
        delay: 0.3
      }} className="w-full max-w-3xl mb-12 md:mb-16" data-id="element-20">
          <div className="w-full aspect-video bg-bg-secondary border border-bg-primary/10 rounded-2xl overflow-hidden relative group cursor-pointer shadow-2xl" data-id="element-21">
            <div className="absolute inset-0 bg-gradient-to-br from-bg-primary/80 to-bg-secondary/90 flex flex-col items-center justify-center p-6 text-center transition-transform duration-500 group-hover:scale-105" data-id="element-22">
              <div className="w-20 h-20 rounded-full bg-accent/20 flex items-center justify-center mb-5 group-hover:bg-accent/30 transition-colors" data-id="element-23">
                <div className="w-16 h-16 rounded-full bg-accent flex items-center justify-center pl-1" data-id="element-24">
                  <Play className="w-7 h-7 text-ink-dark fill-ink-dark" data-id="element-25" />
                </div>
              </div>
              <span className="font-display font-bold text-white text-lg md:text-xl" data-id="element-26">
                Watch the 4-minute briefing
              </span>
            </div>
          </div>
        </motion.div>

        {/* CTA */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        ease: 'easeOut',
        delay: 0.4
      }} className="flex flex-col items-center gap-5 w-full" data-id="element-27">
          <div className="flex flex-col items-center gap-2" data-id="element-28">
            <span className="text-sm md:text-base font-bold tracking-widest uppercase text-bg-primary" data-id="element-29">
              Step 2 of 3: Complete Your Application
            </span>
            <span className="text-sm md:text-base text-bg-primary/60 italic" data-id="element-30">
              (NOTE: Every application is reviewed by one of our team members)
            </span>
          </div>
          <a href="https://form.typeform.com/to/ZIP12HYK" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-20 md:px-28 py-10 md:py-14 bg-bg-primary text-white font-extrabold rounded-full text-4xl md:text-5xl tracking-tight transition-all duration-200 hover:scale-[1.03] hover:bg-bg-secondary shadow-[0_15px_50px_rgba(14,26,53,0.35)] hover:shadow-[0_20px_60px_rgba(14,26,53,0.5)] ring-4 ring-bg-primary/10 hover:ring-bg-primary/20" data-id="element-31">
            Apply for a confidential call{' '}
            <span className="text-accent ml-3" data-id="element-32">→</span>
          </a>
        </motion.div>
      </div>
    </section>;
}